import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';
import { Router } from '@angular/router';
import {
  catchError,
  throwError
} from 'rxjs';

export const unauthorizedInterceptor: HttpInterceptorFn = (
  request,
  next
) => {
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401
      ) {
        // Login endpoint'i 401 dönerse tekrar login sayfasına yönlendirme yapma.
        const isLoginRequest = request.url.includes('/auth/login');

        if (!isLoginRequest) {
          localStorage.removeItem('access_token');

          const returnUrl = router.url;

          router.navigate(
            ['/login'],
            {
              queryParams: {
                returnUrl
              }
            }
          );
        }
      }

      return throwError(() => error);
    })
  );
};